import { api } from '@services';

export interface ManufacturerNameAndId {
  name: string;
  id: string;
}
const getManufacturersAutocomplete = async (
  search: string,
): Promise<ManufacturerNameAndId[]> => {
  const { data: manufacturersNames } = await api.get<ManufacturerNameAndId[]>(
    `/manufacturers/autocomplete/${encodeURIComponent(search)}`,
  );

  return manufacturersNames;
};

export { getManufacturersAutocomplete };
